export default {"src":"/_next/static/media/samsung_logo.5d35d34f.svg","height":87,"width":260};